
export const STORE_XOOK_DATA = "STORE_XOOK_DATA";
export const SET_XOOK_SERVING_DATA = "SET_XOOK_SERVING_DATA";
export const CLEAR_XOOK_DATA = "CLEAR_XOOK_DATA";
export const SET_CURRENCY = "SET_CURRENCY";
export const SET_DATA_POLLING_ID = "SET_DATA_POLLING_ID";

//KitchenVersions 
export const KitchenVersions = Object.freeze({
    "V3" : "V3",
    "V4" : "V4"
});